import React, { useContext, useState } from "react";
import { AppContext } from "../../App";
import "./Profile.scss"; // Import the CSS file
import { Link } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import ConfirmDialog from "../confirmdialog/ConfirmDialog";
import { URL } from "../../constants/url";

const Profile = () => {
  const { user, setBillData, billData } = useContext(AppContext);
  const [showConfirm, setShowConfirm] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const currentDate = new Date();
  let currentYear = currentDate.getFullYear();

  const handleDeleteAllBill = async () => {
    try {
      const response = await fetch(`${URL}/api/bills/`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        setBillData([]);
        setShowConfirm(false);
        setErrorMessage("Delete successfully");
      } else {
        setErrorMessage("not bill to delete");
        setShowConfirm(false);
      }
    } catch (error) {
      setErrorMessage("An error occurred.");
    } finally {
      setShowConfirm(false);
    }
  };

  const handleCancel = () => {
    setShowConfirm(false);
  };

  const handleShowConfirm = () => {
    setShowConfirm(true);
    setTimeout(() => {
      setErrorMessage("");
    }, 5000);
  };

  const handleDownload = () => {
    const jsonData = JSON.stringify(billData, null, 2);
    const blob = new Blob([jsonData], { type: "application/json" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `BillData-${currentYear}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="profile-wrapper">
      <Link to="/">
        <LogoutIcon />
      </Link>
      <div className="frame-blog-profile">
        <div className="frame-children-blog">
          <div className="profile-container">
            {user &&
              user.map((userData, index) => (
                <div className="profile-info" key={index}>
                  <p>
                    <span>Email:</span> {userData.email}
                  </p>
                  <p>
                    <span>Password:</span> {userData.password}
                  </p>
                </div>
              ))}
          </div>
        </div>
        <div className="frame-children-blog">
          <div>
            <button onClick={handleShowConfirm}>Delete All Bills</button>
            <div className="frame-error-message">
              {errorMessage === "Delete successfully" ? (
                <p>{errorMessage}</p>
              ) : (
                <p className="error-message">{errorMessage}</p>
              )}
            </div>
          </div>
        </div>
        <div className="frame-children-blog ">
          <button onClick={handleDownload} className="button-download-bill">
            Download All bills
          </button>
        </div>
        <div className="frame-children-blog comming-soon">coming soon</div>
      </div>
      {showConfirm && (
        <ConfirmDialog
          message="Are you sure you want to delete all bills?"
          onConfirm={handleDeleteAllBill}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
};

export default Profile;
